<template>
  <div>
    <v-select
      :disabled="!isManager"
      :items="payrolls"
      label="Select Payroll"
      v-model="selectedPayroll"
      @change="getSelectedPayroll"
    ></v-select>
  </div>
</template>
<script>
import staffJs from "@/plugins/staff";
import clientsJs from "@/plugins/clients";

export default {
  computed: {
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getRetrieveAllPayrollsRoute() {
      return this.$store.getters.getRetrieveAllPayrollsRoute;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
  },
  data: () => ({
    payrolls: [],
    selectedPayroll: null,
  }),
  async mounted() {
    await this.getAllPayrolls();
  },
  methods: {
    async getAllPayrolls() {
      const payrolls = await staffJs.getAllPayrolls(
        this.getApiUrl + this.getRetrieveAllPayrollsRoute
      );

      if (payrolls.length > 0) {
        this.payrolls = [];
        payrolls.forEach((payroll) => {
          this.payrolls.push({
            id: payroll.id,
            name: `${payroll.name} Payroll`,
            text: `${payroll.name} Payroll`,
            value: payroll,
          });
        });
      }
    },
    getSelectedPayroll(selectedPayroll) {
      this.$emit("get-selected-payroll", selectedPayroll);
    },
  },
};
</script>
